module.exports = __webpack_public_path__ + "static/media/11NEPAD1.64039104.jpg";